// daily quota
export const FETCHING_GET_PRIORIZATION_DAILY_QUOTA = '@@toyota/FETCHING_GET_PRIORIZATION_DAILY_QUOTA';
export const FETCHED_GET_PRIORIZATION_DAILY_QUOTA = '@@toyota/FETCHED_GET_PRIORIZATION_DAILY_QUOTA';
export const FETCH_GET_PRIORIZATION_DAILY_QUOTA_FAILED = '@@toyota/FETCH_GET_PRIORIZATION_DAILY_QUOTA_FAILED';

export const FETCHING_UPDATE_PRIORIZATION_DAILY_QUOTA = '@@toyota/FETCHING_UPDATE_PRIORIZATION_DAILY_QUOTA';
export const FETCHED_UPDATE_PRIORIZATION_DAILY_QUOTA = '@@toyota/FETCHED_UPDATE_PRIORIZATION_DAILY_QUOTA';
export const FETCH_UPDATE_PRIORIZATION_DAILY_QUOTA_FAILED = '@@toyota/FETCH_UPDATE_PRIORIZATION_DAILY_QUOTA_FAILED';

// priorization dates
export const FETCHING_GET_PRIORIZATION_DATES = '@@toyota/FETCHING_GET_PRIORIZATION_DATES';
export const FETCHED_GET_PRIORIZATION_DATES = '@@toyota/FETCHED_GET_PRIORIZATION_DATES';
export const FETCH_GET_PRIORIZATION_DATES_FAILED = '@@toyota/FETCH_GET_PRIORIZATION_DATES_FAILED';

export const FETCHING_GET_ORDERS_BY_DATE = '@@toyota/FETCHING_GET_ORDERS_BY_DATE';
export const FETCHED_GET_ORDERS_BY_DATE = '@@toyota/FETCHED_GET_ORDERS_BY_DATE';
export const FETCH_GET_ORDERS_BY_DATE_FAILED = '@@toyota/FETCH_GET_ORDERS_BY_DATE_FAILED';

export const FETCHING_ORDERS_AMOUNT_BY_DATE = '@@toyota/FETCHING_ORDERS_AMOUNT_BY_DATE';
export const FETCHED_ORDERS_AMOUNT_BY_DATE = '@@toyota/FETCHED_ORDERS_AMOUNT_BY_DATE';
export const FETCH_ORDERS_AMOUNT_BY_DATE_FAILED = '@@toyota/FETCH_ORDERS_AMOUNT_BY_DATE_FAILED';

export const UPDATE_ORDERS_AMOUNT_BY_DATE = '@@toyota/UPDATE_ORDERS_AMOUNT_BY_DATE';
export const UPDATED_ORDERS_AMOUNT_BY_DATE = '@@toyota/UPDATED_ORDERS_AMOUNT_BY_DATE';
export const UDATE_ORDERS_AMOUNT_BY_DATE_FAILED = '@@toyota/UDATE_ORDERS_AMOUNT_BY_DATE_FAILED';

export const FETCH_FREE_DATES_LOGISTIC = '@@toyota/FETCH_FREE_DATES_LOGISTIC';
export const FETCHED_FREE_DATES_LOGISTIC = '@@toyota/FETCHED_FREE_DATES_LOGISTIC';
export const FETCH_FREE_DATES_LOGISTIC_FAILED = '@@toyota/FETCH_FREE_DATES_LOGISTIC_FAILED';


export const REMOVE_VEHICLES_PRIORIZATION = '@@toyota/REMOVE_VEHICLES_PRIORIZATION';
export const REMOVED_VEHICLES_PRIORIZATION = '@@toyota/REMOVED_VEHICLES_PRIORIZATION';
export const REMOVE_VEHICLES_PRIORIZATION_FAILED = '@@toyota/REMOVE_VEHICLES_PRIORIZATION_FAILED';

export const FETCHING_PRIORIZATION_COMBOS = '@@toyota/FETCHING_PRIORIZATION_COMBOS';
export const FETCHED_PRIORIZATION_COMBOS = '@@toyota/FETCHED_PRIORIZATION_COMBOS';
export const FETCH_PRIORIZATION_COMBOS_FAILED = '@@toyota/FETCH_PRIORIZATION_COMBOS_FAILED';

export const UPDATE_VEHICLE_COMBO = '@@toyota/UPDATE_VEHICLE_COMBO';
export const UPDATED_VEHICLE_COMBO = '@@toyota/UPDATED_VEHICLE_COMBO';
export const UPDATE_VEHICLE_COMBO_FAILED = '@@toyota/UPDATE_VEHICLE_COMBO_FAILED';

export const DELETING_DATES_PRIORIZATION = '@@toyota/DELETING_DATES_PRIORIZATION';
export const DELETE_DATES_PRIORIZATION = '@@toyota/DELETE_DATES_PRIORIZATION';
export const DELETE_DATES_PRIORIZATION_FAILED = '@@toyota/DELETE_DATES_PRIORIZATION_FAILED';

export const CLEAN_ORDERS_BY_DATE = '@@toyota/CLEAN_ORDERS_BY_DATE';
export const PRIORIZATION_DUMMY_ACTION = '@@toyota/PRIORIZATION_DUMMY_ACTION';
export const SET_SELECTED_VEHICLE_COMBO = '@@toyota/SET_SELECTED_VEHICLE_COMBO';

export const SET_SELECTED_VEHICLE_AGENCY = '@@toyota/SET_SELECTED_VEHICLE_AGENCY';
export const UPDATE_VEHICLE_AGENCY = '@@toyota/UPDATE_VEHICLE_AGENCY';
export const UPDATED_VEHICLE_AGENCY = '@@toyota/UPDATED_VEHICLE_AGENCY';
export const UPDATE_VEHICLE_AGENCY_FAILED = '@@toyota/UPDATE_VEHICLE_AGENCY_FAILED';

export const FETCHING_SUGGESTED_PRIORIZATION_DATES = '@@toyota/FETCHING_SUGGESTED_PRIORIZATION_DATES';
export const FETCHED_SUGGESTED_PRIORIZATION_DATES = '@@toyota/FETCHED_SUGGESTED_PRIORIZATION_DATES';
export const FETCHED_SUGGESTED_PRIORIZATION_DATES_FAILED = '@@toyota/FETCHED_SUGGESTED_PRIORIZATION_DATES_FAILED';
export const CLEAN_SUGGESTED_PRIORIZATION_DATES = '@@toyota/CLEAN_SUGGESTED_PRIORIZATION_DATES';

export const SAVING_PRIORIZATION = '@@toyota/SAVING_PRIORIZATION';
export const SAVED_PRIORIZATION = '@@toyota/SAVED_PRIORIZATION';
export const SAVED_PRIORIZATION_FAILED = '@@toyota/SAVED_PRIORIZATION_FAILED';

export const SAVING_LOGISTIC_OBSERVATION = '@@toyota/SAVING_LOGISTIC_OBSERVATION';
export const SAVED_LOGISTIC_OBSERVATION = '@@toyota/SAVED_LOGISTIC_OBSERVATION';
export const SAVED_LOGISTIC_OBSERVATION_FAILED = '@@toyota/SAVED_LOGISTIC_OBSERVATION_FAILED';

